import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Collapse from '@kunukn/react-collapse'

import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import { collapsibleClick } from '@cred/react-analytics/events'

import { fireGtmEvent } from 'utils/gtm'
import { PartnerLogo } from 'components/partner-logo'
import RateTableCtaButton from 'components/RateTableCtaButton'
import { addTrackingParamsToUrl } from 'utils/urls'
import mapLenderSlagToTrackingName from 'utils/mapLenderSlagToTrackingName'
import { REFI } from 'common/const/verticalNames'
import RateTableDisclosureButton from 'components/RateTableDisclosureButton'
import { useViewport } from 'components/hooks'
import RateTableAprValue from 'components/RateTableAprValue'

import styles from './styles.module.scss'
import disclaimers from './disclaimers'

const LenderRate = ({
  trackSnowplowEvent,
  lender,
  widgetContext,
  ctaUrl,
  shouldDarkenBorder,
  blank = true,
}) => {
  const [open, setOpen] = useState(false)
  const { xSmall } = useViewport()

  const toggleLendersDisclosuresModal = () => {
    trackSnowplowEvent(collapsibleClick, {
      text: 'Disclaimers',
      action: open ? 'collapse' : 'expand',
    })

    setOpen((prevOpen) => !prevOpen)
  }

  const onClickCta = () => {
    const lenderData = { lender: lender.name }

    fireGtmEvent('ctaClick', Object.assign(lenderData, widgetContext))
  }

  const darkenBorderClass = shouldDarkenBorder ? styles.darkenedBorder : ''

  const ctaUrlWithTrackingParams = addTrackingParamsToUrl({
    widgetContext,
    lenderSlug: mapLenderSlagToTrackingName(lender.slug, REFI),
    url: ctaUrl,
  })

  return (
    <div
      data-test-id={`rateTableTile_${lender.rateSlug}`}
      className={`${styles.panel} ${darkenBorderClass}`}
    >
      <div className="pure-g">
        <div className="pure-u-1 pure-u-md-1-4 pure-u-sm-1-1 ">
          <PartnerLogo partner={lender.slug} />
          {disclaimers[lender.slug] && !xSmall && (
            <RateTableDisclosureButton
              testid="toggle-button"
              open={open}
              onClick={toggleLendersDisclosuresModal}
              isMobile={xSmall}
              className={styles.disclaimerWrapperDesktop}
            />
          )}
        </div>
        <RateTableAprValue
          minRate={lender.minFixedRate}
          maxRate={lender.maxFixedRate}
          withBottomBorder
        />
        {lender.minVariableRate ? (
          <RateTableAprValue
            minRate={lender.minVariableRate}
            maxRate={lender.maxVariableRate}
            isVariable
          />
        ) : (
          <div className="pure-u-1 pure-u-md-1-4 pure-u-sm-1-3" />
        )}
        <div className="pure-u-1 pure-u-md-1-4 pure-u-sm-1-3">
          <RateTableCtaButton
            data-testid="cta-button"
            containerClassName={styles.CTAdesktop}
            target={blank ? '_blank' : '_self'}
            transparent={!xSmall}
            href={ctaUrlWithTrackingParams}
            onClick={onClickCta}
            fullWidth={xSmall}
          />
          {disclaimers[lender.slug] && xSmall && (
            <RateTableDisclosureButton
              testid="toggle-button"
              open={open}
              onClick={toggleLendersDisclosuresModal}
              isMobile={xSmall}
              className={styles.disclaimerWrapperMobile}
            />
          )}
        </div>
        <div className="pure-u-1">
          <Collapse className={styles.dropdown} isOpen={open}>
            <div className={`${styles.disclosure} mt-24 mb-16 disclaimer neutral500`}>
              {disclaimers[lender.slug]}
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  )
}

LenderRate.propTypes = {
  blank: PropTypes.bool,
  lender: PropTypes.object,
  ctaUrl: PropTypes.string,
  widgetContext: PropTypes.object,
  trackSnowplowEvent: PropTypes.func,
  shouldDarkenBorder: PropTypes.bool,
}

export { LenderRate }

export default withSnowplowContexts(LenderRate)
